import axios from "../../config/axiosConfig";
import { CREATE_CREDIT_NOTE_BILL_BASE, GET_CREDIT_NOTE_BILL_BASES, CREDIT_NOTE_BILL_BASE_REQUEST, UPDATE_CREDIT_NOTE_BILL_BASE,
  DELETE_CREDIT_NOTE_BILL_BASE, CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_CREDIT_NOTE_BILL_BASES_PAGE } from "../types";
import { Entry_Type } from '@/utils';

export const getCreditNoteBillBasesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Debit_Account_Id,Broker_Id,Item_Id'
      };
      return axios.get("/credit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTE_BILL_BASES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCreditNoteBillBases = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/credit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTE_BILL_BASES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCreditNoteBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/credit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCreditNoteBillBaseById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
    
      return axios.get(`/credit-note-bill-base/get/${id}`).then((response) => {
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createCreditNoteBillBase = (creditNoteBillBase) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const newCreditNoteBillBase = {
        ...creditNoteBillBase
      };
      return axios.post("/credit-note-bill-base/add", newCreditNoteBillBase,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_CREDIT_NOTE_BILL_BASE, payload: response.data });
        } else {
          dispatch({
            type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Credit Note Bill Base create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCreditNoteBillBase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.put("/credit-note-bill-base/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CREDIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Credit Note Bill Base update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCreditNoteBillBase = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/credit-note-bill-base/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CREDIT_NOTE_BILL_BASE, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Debit_Account_Id','Broker_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id', 'Party_Note_No'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { inventory: { creaditNoteBillBase: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getCreditNoteBillBasesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedVchNoCreditNotesBillBase = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/credit-note-bill-base/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCreditNotesBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/credit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const sendMailCreditNoteBillBase = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('creditNoteId', mailData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `credit_node_${mailData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note-bill-base/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappCreditNoteBillBase = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('creditNoteId', whatsappData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `credit_node_${whatsappData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note-bill-base/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};


export const getAllPurchaseBillByInvoiceNoInCreditNoteBillBase = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
      };
      return axios.get(`/credit-note-bill-base/get-all-purchase-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPaymentDetailsByCreditNoteBillBaseId = (id) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        billId: id,
        billType: Entry_Type.CREDIT_NOTE_BILL_BASE
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-id`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};